import i18n from 'helpers/i18n';
import messages from './messages';

export type IndicatorScoreValue = -1 | 0 | 50 | 100 | null;

/**
 * Converts an indicator score (-1, 0, 50, 100) into its range label.
 * Returns `null` when the indicator has not been scored.
 */
export function indicatorScoreToRange(
  score: IndicatorScoreValue | undefined
): string | null {
  switch (score) {
    case 0:
      return i18n.ft(messages.low);
    case 50:
      return i18n.ft(messages.mid);
    case 100:
      return i18n.ft(messages.high);
    case -1:
      return i18n.ft(messages.notApplicable);
    default:
      return null;
  }
}
